export const REFRESH_SESSION_URL = "/current-session/refresh-session";
